"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SCRIPT_ID = exports.DEFAULT_ONLOAD_NAME = exports.DEFAULT_CONTAINER_ID = exports.CONTAINER_STYLE_SET = void 0;
exports.getTurnstileSizeOpts = getTurnstileSizeOpts;
exports.isScriptInjected = exports.injectTurnstileScript = void 0;
var SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js";
var DEFAULT_SCRIPT_ID = "cf-turnstile-script";
exports.DEFAULT_SCRIPT_ID = DEFAULT_SCRIPT_ID;
var DEFAULT_ONLOAD_NAME = "onloadTurnstileCallback";
exports.DEFAULT_ONLOAD_NAME = DEFAULT_ONLOAD_NAME;
var DEFAULT_CONTAINER_ID = "cf-turnstile";

/**
 * Function to check if script has already been injected
 *
 * @param scriptId
 * @returns
 */
exports.DEFAULT_CONTAINER_ID = DEFAULT_CONTAINER_ID;
var isScriptInjected = function isScriptInjected(scriptId) {
  return !!document.querySelector("#".concat(scriptId));
};

/**
 * Function to inject the cloudflare turnstile script
 *
 * @param param0
 * @returns
 */
exports.isScriptInjected = isScriptInjected;
var injectTurnstileScript = function injectTurnstileScript(_ref) {
  var render = _ref.render,
    onLoadCallbackName = _ref.onLoadCallbackName,
    onLoad = _ref.onLoad,
    _ref$scriptOptions = _ref.scriptOptions,
    _ref$scriptOptions2 = _ref$scriptOptions === void 0 ? {} : _ref$scriptOptions,
    _ref$scriptOptions2$n = _ref$scriptOptions2.nonce,
    nonce = _ref$scriptOptions2$n === void 0 ? "" : _ref$scriptOptions2$n,
    _ref$scriptOptions2$d = _ref$scriptOptions2.defer,
    defer = _ref$scriptOptions2$d === void 0 ? true : _ref$scriptOptions2$d,
    _ref$scriptOptions2$a = _ref$scriptOptions2.async,
    async = _ref$scriptOptions2$a === void 0 ? true : _ref$scriptOptions2$a,
    _ref$scriptOptions2$i = _ref$scriptOptions2.id,
    id = _ref$scriptOptions2$i === void 0 ? "" : _ref$scriptOptions2$i,
    appendTo = _ref$scriptOptions2.appendTo;
  var scriptId = id || DEFAULT_SCRIPT_ID;

  // Script has already been injected, just call onLoad and does nothing else
  if (isScriptInjected(scriptId)) {
    onLoad();
    return;
  }

  // Generate the js script
  var js = document.createElement("script");
  js.id = scriptId;
  var params = {
    render: render === "explicit" ? render : "",
    onload: render === "explicit" ? onLoadCallbackName : ""
  };
  var searchParams = new URLSearchParams(params);
  js.src = "".concat(SCRIPT_URL, "?").concat(searchParams);
  if (nonce) {
    js.nonce = nonce;
  }
  js.defer = !!defer;
  js.async = !!async;
  js.onload = onLoad;

  // Append it to the body|head
  var elementToInjectScript = appendTo === "body" ? document.body : document.getElementsByTagName("head")[0];
  elementToInjectScript.appendChild(js);
};
exports.injectTurnstileScript = injectTurnstileScript;
var CONTAINER_STYLE_SET = {
  normal: {
    width: 300,
    height: 65
  },
  compact: {
    width: 130,
    height: 120
  },
  invisible: {
    width: 0,
    height: 0,
    overflow: "hidden"
  }
};

/**
 * Convert the size from component props, and filter it for Turnstile parameters
 * while keeping the types.
 *
 * @param size Size from props.
 * @returns
 */
exports.CONTAINER_STYLE_SET = CONTAINER_STYLE_SET;
function getTurnstileSizeOpts(size) {
  var result;
  if (size !== "invisible") {
    result = size;
  }
  return result;
}